import { usePermissions } from 'hooks/permissions/usePermissions';
import {
  EditableFieldValuesEntityName,
  EditableStandardEntityName,
  editableFieldValuesEntityNames,
} from 'shared/domain/fieldValue/fields';
import { isAdmin } from 'shared/domain/role/isAdmin';
import { useCurrentUserRole } from 'store/user';

export function useCanCreate(
  entityName?:
    | string
    | EditableFieldValuesEntityName
    | EditableStandardEntityName
): boolean {
  const {
    canCreateCompany,
    canCreateContract,
    canCreateSite,
    canCreateLevel,
    canCreateUser,
    canCreateOrganization,
  } = usePermissions();
  const userRole = useCurrentUserRole();

  if (!entityName) {
    return false;
  }

  switch (entityName) {
    case EditableStandardEntityName.company:
      return canCreateCompany().permission;
    case EditableStandardEntityName.contract:
      return canCreateContract().permission;
    case EditableStandardEntityName.location:
      return canCreateSite().permission;
    case EditableStandardEntityName.level:
      return canCreateLevel().permission;
    case EditableStandardEntityName.user:
      return canCreateUser().permission;
    case EditableStandardEntityName.organization:
      return canCreateOrganization().permission;
    default:
      return (
        editableFieldValuesEntityNames.some(
          (name) => name === entityName
        ) && isAdmin(userRole)
      );
  }
}
